<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.basic200.pb-0
        v-row(no-gutters)
          v-col
            h6.mb-0.basic800--text {{ $t('update_securepay') }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="default" :size="24") mdi-close

      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")

            .registered(v-if="gatewayId")
              div {{ $t('securepay_text') }}
              v-layout.mt-3
                v-btn.primary(block depressed @click="viewSecurePayDashboard(loginUrl)") {{ $t('securepay_dashboard') }}
              v-divider.my-5

            .registered-ic
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('registered_ic.label') }}
              v-text-field.p1(solo flat background-color="basic200" height="40" v-model='accountIc' :label="$t('registered_ic.label')" :placeholder="$t('registered_ic.placeholder')" outlined dense persistent-hint hide-details :rules="rules.not_empty" @keypress="isNumber($event)")

            .account-list
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('account_list.label') }}
              .empty(v-if="accountList.length === 0")
                v-card.pa-4(flat outlined)
                  .caption {{ $t('account_list.no_account_found') }}:
                  v-btn.primary.my-2(small block depressed @click="clickRegister(registerUrl)" height="32") {{ $t('register') }}
                  div.caption(@click="refreshAccountList(accountIc)") Already registered?&nbsp;
                    span.textColorAccent--text.clickable(style="text-decoration: underline;")
                      | {{ $t('refresh_list') }}
                      v-icon(x-small color="textColorAccent") mdi-refresh
                  .c1.mt-3.basic600--text *{{ $t('account_activation_footnote') }}
              .list(v-else)
                .list-item.my-2
                  v-row(v-for='account in accountList' :key="account.id" no-gutters align="center")
                    v-col.shrink(@click="selectedAccount = account.id")
                      v-btn(icon small)
                        template(v-if="selectedAccount == account.id")
                          v-icon(color='success') mdi-check-circle
                        template(v-else)
                          v-icon(color='primary400') mdi-radiobox-blank
                    v-col
                      span.ml-1 {{ account.company_name }}
                        span.c1.ml-1(v-if="account.status !== 'verified'") 
                          span (
                          span.danger--text {{ account.status }}
                          span )
                  
                  .c1.mt-2(v-if="accountList.filter(f => f.status !== 'verified').length > 0") {{ $t('securepay_account_activation_text') }}

      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-small(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave' :disabled="!selectedAccount || accountList.length === 0")
          | {{ $t('update') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'UpdateSecurepay',
  props: ['open', 'company'],
  data: () => ({
    isFetching: true,
    gatewayId: null,
    accountIc: null,
    accountList: [],
    selectedAccount: null,
    registerUrl: process.env.VUE_APP_SECUREPAY_REGISTER_URL,
    loginUrl: process.env.VUE_APP_SECUREPAY_LOGIN_URL,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    ...mapState('user', ['user']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    accountIc (ic) {
      this.fetchAccounts(ic)
    }
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    fetchSettings () {
      this.$axios.get(`/securepay_creds/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const gateway = response.data.results[0]
          this.gatewayId = gateway.id
          this.accountIc = gateway.account.owner_ic
          this.selectedAccount = gateway.account.id
        }
        this.isFetching = false
      })
      .catch(() => {})
      .finally(() => {
        if (!this.gatewayId) {
          this.$axios.get(`/users/${this.user.id}/`).then((response) => {
            this.accountIc = response.data.ic
          })
          .catch(() => {})
          .finally(() => {
            if (this.accountIc) {
              this.fetchAccounts(this.accountIc)
            }
          })
        }
      })
    },
    refreshAccountList(ic) {
      this.$axios.post('/securepay_accounts/refresh_list').catch(() => {})
      this.fetchAccounts(ic)
    },
    fetchAccounts(ic) {
      this.$axios.get(`/securepay_accounts/?owner_ic=${ic}`).then((response) => {
        this.accountList = response.data.results
      })
      .catch(() => {
        this.accountList = []
      })
    },
    clickRegister (url) {
      window.open(url)
    },
    viewSecurePayDashboard (url) {
      window.open(url)
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('account', this.selectedAccount)
      if (this.gatewayId) {
        this.axios.put(`/securepay_creds/${this.gatewayId}/`, params)
        .then(resp => {
          console.log(resp)
          this.updateAccountIc(this.accountIc)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/securepay_creds/`, params)
        .then(resp => {
          this.$emit('activated', resp.data)
          this.updateAccountIc(this.accountIc)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateAccountIc(ic) {
      this.$axios.patch(`/users/${this.user.id}/`, {ic: ic})
      .catch(() => {})
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_securepay": "SecurePay",
    "registered_ic": {
      "label": "Registered Business Owner IC",
      "placeholder": "Paste business owner IC number registered in SecurePay"
    },
    "account_list": {
      "label": "Account List",
      "placeholder": "Write your secret key here",
      "no_account_found": "No account found for this IC number. Register your SecurePay account here"
    },
    "securepay_text": "This account is managed by SecurePay. Go to SecurePay dashboard to view payout status or update account information.",
    "securepay_dashboard": "SecurePay Dashboard",
    "register": "Register",
    "refresh_list": "Refresh list",
    "account_activation_footnote": "Your securepay account activation will take some time due to securepay verifcation process. This may take up to 24 hours. An email/sms will be sent when your securepay account is ready.",
    "securepay_account_activation_text": "Your securepay account activation will take some time due to securepay verifcation process. This may take up to 24 hours. An email/sms will be sent when your securepay account is ready."
  }
}
</i18n>